import { helper as $h } from '@/utils/helper';

const state = () => {
    return {
        menu: [
            {
                icon: 'HomeIcon', // Иконка для сабменю
                pageName: 'home', // Берет из роутера имя и подставляет его PATH
                title: 'Главная', // Название отображения
            },
            {
                icon: 'LayoutIcon',
                pageName: '',
                title: 'Контент',
                subMenu: [
                    {
                        icon: 'LayoutIcon',
                        pageName: 'pages',
                        title: 'Страницы',
                    },
                    {
                        icon: 'PaperclipIcon',
                        pageName: 'page-categories',
                        title: 'Категории',
                    },
                    {
                        icon: '',
                        pageName: 'content-banners',
                        title: 'Баннеры',
                    },
                    {
                        icon: 'ThumbsUpIcon',
                        pageName: 'reviews',
                        title: 'Отзывы',
                    },
                    {
                        icon: 'ImageIcon',
                        pageName: 'attractions',
                        title: 'Достопримечательности',
                    },
                    {
                        icon: 'ArrowUpRightIcon',
                        pageName: 'popular-directions',
                        title: 'Популярные направления',
                    },
                    {
                        icon: 'ArrowUpIcon',
                        pageName: 'city-directions',
                        title: 'Города отправлений',
                    },
                    {
                        icon: 'ArrowDownIcon',
                        pageName: 'city-arrivals',
                        title: 'Города прибытий',
                    },
                    {
                        icon: 'PaperclipIcon',
                        pageName: 'content-profile-documents',
                        title: 'Документы в профиле',
                    },
                    {
                        icon: 'HelpCircleIcon',
                        pageName: 'faq',
                        title: 'FAQ',
                    },
                ],
            },
            {
                icon: 'LayoutIcon',
                pageName: '',
                title: 'Круизы и Теплоходы',
                subMenu: [
                    {
                        icon: 'LifeBuoyIcon',
                        pageName: 'cruises',
                        title: 'Круизы',
                    },
                    {
                        icon: 'AnchorIcon',
                        pageName: 'ships',
                        title: 'Теплоходы',
                    },
                    {
                        icon: 'TagIcon',
                        pageName: 'discounts',
                        title: 'Акции',
                    },
                    {
                        icon: 'TagIcon',
                        pageName: 'tariffs',
                        title: 'Тарифы',
                    },
                    {
                        icon: 'StarIcon',
                        pageName: 'special-discounts',
                        title: 'Специальные скидки',
                    },
                    {
                        icon: 'ShoppingCartIcon',
                        pageName: 'offers',
                        title: 'Спецпредложения',
                    },
                    {
                        icon: 'TargetIcon',
                        pageName: 'points',
                        title: 'Точки маршрутов',
                    },
                ],
            },
            {
                icon: 'ShoppingCartIcon',
                pageName: 'orders',
                title: 'Заказы',
            },
            {
                icon: 'UsersIcon',
                pageName: 'customers',
                title: 'Покупатели',
            },
            {
                icon: 'UsersIcon',
                pageName: 'managers',
                title: 'Менеджеры',
            },
            {
                icon: 'UsersIcon',
                pageName: 'users',
                title: 'Пользователи системы',
            },
            {
                icon: 'ActivityIcon',
                pageName: 'indexes',
                title: 'Индексация',
            },
        ],
        formattedMenu: null,
    };
};

// getters
const getters = {
    menu: ({ menu }) => menu,
    formattedMenu: (state) => state.formattedMenu,
};

// actions
const actions = {
    formatMenu({ commit, getters }, { userRules, router }) {
        commit('setFormattedMenu', $h.allowedMenu(getters.menu, userRules, router));
    },
};

// mutations
const mutations = {
    setMenu(state, payload) {
        state.menu = payload;
    },
    clearMenuState(state) {
        state.menu = null;
    },
    setFormattedMenu(state, payload) {
        state.formattedMenu = payload;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
